import { FC } from "react";
import "./App.css";
import MainRoutes from "./routes";

const App: FC = () => {
  return (
    <div className="fullscreen-container">
      <MainRoutes />
    </div>
  );
};

export default App;
